<template>
  <!-- <b-container class=""> -->
      <div class="_card-columns" >
        <b-row class="pl-1 pr-1">
        <shop-category-item
          v-for="(ShopCategory, index) in panelData"
          :key="index" 
          :index="index"        
          :ShopCategory="ShopCategory"/>    

        </b-row>      
      </div> 
 <!--  </b-container> -->
</template>

<script>
import ShopCategoryItem from "@/components/ShopCategoryItem";

export default {
  name: "ShopCategoriesPanel",
  props: [
    "searchTag",
  ],
  components: {
    ShopCategoryItem
  },
  computed: {
    getSelectedLanguage() {
      return this.$store.getters.getLanguage;
    }
  },
  methods: {
    async loadGroupsFromServer(searchTags) {

      let config =this.$store.getters.getRestHeaderConfig;
        config.params = {
            searchTags: searchTags,
            imageSize: "medium" /* small, medium, big */,
            localeId: this.getSelectedLanguage.ident /* Language: de, en */
        };

      await this.$http
        .get(
          this.$store.getters.getRestServerBaseUrl + "/productGroups",
          config
        )
        .then(response => {
         // console.log("productGroups came back ok: ", response.data);

          // Check Data ?
          this.panelData = response.data;
        })
        .catch(err => {
          console.log(err);
          this.panelData = [];
        });
    }
  },
  data() {
    return {
      CardOptions: {
        imageAlt: "Image",
        tag: "article",
        titleClass: "card-text text-center",
        style: 'cursor: pointer;',
        class: ""
      },
      panelData: []
    };
  },
  mounted() {
    /* Load Groups to show in Panel */
    //console.log('SearchTag: ', this.searchTag);
    
    this.loadGroupsFromServer(this.searchTag);
  }
};
</script>
